import { c as _c } from "react/compiler-runtime";
import { useGetDrawResult } from '../../draw/entry.js';
import { calculateGroupWinAmounts } from '../utils/calculateGroupWinAmounts.js';
import { calculatePlayerWinAmount } from '../utils/calculatePlayerWinAmount.js';
import { useWager } from './useWager.js';
const getGroupWinAmounts = (drawNumber, groupWinAmounts) => {
  const currentGroupWinAmounts = groupWinAmounts?.[drawNumber] || groupWinAmounts?.['total'];
  const groupWinAmount = currentGroupWinAmounts?.group ?? 0;
  const playerWinAmount = currentGroupWinAmounts?.share ?? 0;
  return {
    groupWinAmount,
    playerWinAmount
  };
};
/**
 * Hook to get the win amount for a wager.
 *
 * @param root0 props for useGetWinAmount
 * @param root0.wagerId Wager ID for current wager
 * @param root0.winDivisionsRowCount Array of number of rows in each win division
 * @param root0.marketplaceWagerDetails Optional parameter for marketplace wager details
 * @returns Win amount for the wager
 */
export function useGetWinAmount(t0) {
  const $ = _c(11);
  const {
    wagerId,
    winDivisionsRowCount,
    marketplaceWagerDetails
  } = t0;
  const wager = useWager(wagerId);
  const {
    completedDraws
  } = wager.data;
  const {
    isGroup
  } = wager.data.wagerInfo;
  const {
    product,
    drawNumber,
    betAmount
  } = wager.data.coupon;
  const {
    groupWinAmounts,
    customerShareCount,
    totalShareCount
  } = wager.data.marketplace || {};
  let t1;
  if ($[0] !== drawNumber || $[1] !== product) {
    t1 = {
      product,
      drawNumber
    };
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const drawResults = useGetDrawResult(t1);
  if (drawResults.isError || drawResults.data.type === "NONE") {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        groupData: undefined,
        winAmount: 0
      };
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const {
    winDivisions
  } = drawResults.data.data;
  let t2;
  if ($[4] !== betAmount || $[5] !== winDivisions || $[6] !== winDivisionsRowCount) {
    t2 = calculatePlayerWinAmount(winDivisions, betAmount, winDivisionsRowCount);
    $[4] = betAmount;
    $[5] = winDivisions;
    $[6] = winDivisionsRowCount;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let playerWinAmount = t2;
  let groupData;
  if (isGroup && marketplaceWagerDetails) {
    const isDrawCompleted = completedDraws.find(completedDraw => completedDraw.drawNumber === drawNumber);
    groupData = isDrawCompleted ? getGroupWinAmounts(drawNumber, groupWinAmounts) : calculateGroupWinAmounts({
      winDivisions,
      winDivisionsRowCount,
      customerShareCount,
      totalShareCount,
      betAmount
    });
    playerWinAmount = groupData.playerWinAmount;
  }
  let t3;
  if ($[8] !== groupData || $[9] !== playerWinAmount) {
    t3 = {
      groupData,
      winAmount: playerWinAmount
    };
    $[8] = groupData;
    $[9] = playerWinAmount;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}